import { core } from '@tock/coretypes';
import DestinationsScroller from 'components/profile/DestinationsScroller';
import ProfileSection from 'components/profile/ProfileSection';

interface Props {
  isLoading: boolean;
  patronProfile: core.PatronProfile;
}

const ProfileDestinationsSection = ({ isLoading, patronProfile }: Props) => {
  if (!isLoading && patronProfile.patronDestinations.length === 0) {
    return null;
  }
  return (
    <ProfileSection name="Your bucket list food destinations" isLoading={isLoading}>
      <DestinationsScroller destinations={patronProfile.patronDestinations} />
    </ProfileSection>
  );
};

export default ProfileDestinationsSection;
